import { toast, ToastOptions, Slide } from "react-toastify";

const defaultOptions: ToastOptions = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  theme: "colored",
  transition: Slide,
  style: { zIndex: 11000 },
};

// Expose helper methods
export const notify = {
  success: (msg: string, options: ToastOptions = {}) =>
    toast.success(msg, { ...defaultOptions, ...options }),

  error: (msg: string, options: ToastOptions = {}) =>
    toast.error(msg, { ...defaultOptions, ...options }),

  info: (msg: string, options: ToastOptions = {}) =>
    toast.info(msg, { ...defaultOptions, ...options }),

  warn: (msg: string, options: ToastOptions = {}) =>
    toast.warn(msg, { ...defaultOptions, ...options }),

  promise: <T>(
    promise: Promise<T>,
    messages: { pending: string; success: string; error: string },
    options: ToastOptions = {},
  ) =>
    toast.promise(
      promise,
      {
        pending: messages.pending,
        success: messages.success,
        error: messages.error,
      },
      { ...defaultOptions, ...options },
    ),
};
